// @flow
import * as React from 'react'
import { DisplacementArrow } from 'components/displacementArrow'
import config from 'config'
import { asyncReactor } from 'components/async-reactor'
import './styles.scss'

const gradient = config.gradient

type ResponsiveImage = {
  src: string,
  srcSet: string,
  placeholder?: string,
  width: number,
  height: number
}

type Props = {
  category: string,
  current: string,
  image?: ResponsiveImage,
  previous: string
}

function TopImage ({ category, current, image, previous }: Props) {
  return (
    <div
      className='top image'
      style={{
        backgroundImage: !image
          ? gradient[category][0]
          : `url(${image.placeholder})`
      }}
    >
      {image && (
        <div
          style={{
            paddingBottom: `${image.height / image.width * 100}%`,
            position: 'relative'
          }}
        >
          <img
            className='ui fluid image'
            src={image.src}
            srcSet={image.srcSet}
            sizes='(min-width: 800px) 33vw, (min-width: 600px) 50vw, 100vw'
            alt=''
            style={{ position: 'absolute' }}
          />
        </div>
      )}
      <div
        className='rank-container'
        style={{
          backgroundImage: `linear-gradient(
            135deg,
            ${gradient[category][2]} ${!image ? '0%' : '60%'},
            ${gradient[category][1]} 90%)`
        }}
      >
        <div className='rank'>
          <div className='previous-rank'>
            {previous}
            <DisplacementArrow current={current} previous={previous} />
          </div>
          <div className='ui huge infographic inverted header'>{current}</div>
        </div>
      </div>
    </div>
  )
}

/**
 * Tries to load the image dynamically.
 * @param props
 * @return {Promise<*>}
 * @constructor
 */
async function TopWithImage (props: { imageName: string } & Props) {
  const { imageName } = props
  const image = await import(/* webpackMode: "eager" */ `images/hotels/${imageName}.jpg`)

  return <TopImage {...props} image={image} />
}

/**
 * Async component: tries to load the image dynamically. While loading, it
 * will show a version of the component without the image – and also when it
 * fails.
 */
export const AsyncTopImage: React.Component<
  Props & { imageName: string }
> = asyncReactor(TopWithImage, TopImage)



// WEBPACK FOOTER //
// ./src/components/topImage/component.js